import React, { useContext } from 'react';
import ChatFillIcon from 'components/lib/icons/chat_fill_icon';
import FloorboardRow from './floorboard_row';
import LiveboardContext from 'components/liveboards/contexts/liveboard_context.jsx';

export default function ChatRow() {
  const { channel, sla } = useContext(LiveboardContext);

  const stats = channel.chat;
  const chatSla = sla.chat;
  return (
    <FloorboardRow
      newItems={stats.currentNewChats}
      activeItems={stats.currentActiveChats}
      currentWait={stats.currentWait}
      sla={chatSla}
      activeLabel="Active Chats"
      newLabel="New Chats"
      waitLabel="Oldest Unanswered Chat"
      icon={<ChatFillIcon />}
    />
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/floorboard/chat_row.jsx